import React from 'react'

const UpdateGovtOrderDetailsModal = ({updateHandleChange, selectedRowsData}) => {
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              {/* <h5 class="modal-title" id="imageZoomModalTitle">Galeria</h5> */}
              <button
                type="button"
                class="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Update Add Govt Order Details</h4>
                    <form className="form-sample">
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div class="col-md-3">
                        <div className="form-group">
                            <label htmlFor="Location">Location</label>
                            <input
                              type="text"
                              className="form-control"
                              name="location"
                              id="Location"
                              readOnly
                              value={selectedRowsData.company && selectedRowsData.company.location}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                        <div className="form-group">
                            <label htmlFor="Company">Company Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="Company"
                              id="Location"
                              readOnly
                              value={selectedRowsData.company && selectedRowsData.company.company_name}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                        <div className="form-group">
                            <label htmlFor="Size">Size</label>
                            <input
                              type="text"
                              className="form-control"
                              name="size"
                              id="Size"
                              readOnly
                              value={selectedRowsData.size}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div class="col-md-3">
                        <div className="form-group">
                            <label htmlFor="Size">Alloted</label>
                            <input
                              type="text"
                              className="form-control"
                              name="alloted"
                              id="Size"
                              readOnly
                              value={selectedRowsData.alloted}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Placed">Order Placed</label>
                            <input
                              type="text"
                              className="form-control"
                              name="order_placed"
                              id="Placed"
                              value={selectedRowsData.location}
                              onChange={updateHandleChange}
                              
                            />
                          </div>
                        </div>
                        <div className="col-md-8">
                          <div className="form-group">
                            <label htmlFor="Details">Order Details</label>
                            <input
                              type="text"
                              className="form-control"
                              name="order_details"
                              id="Details"
                              value={selectedRowsData.order_details}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="rca_qty">RCA Quantity</label>
                            <input
                              type="text"
                              className="form-control"
                              name="rca_qty"
                              id="rca_qty"
                              value={selectedRowsData.rca_qty}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Order">Order Quantity</label>
                            <input
                              type="text"
                              className="form-control"
                              name="order_qty"
                              id="Order"
                              value={selectedRowsData.order_qty}
                              onChange={updateHandleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        onClick={updateHandleChange}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default UpdateGovtOrderDetailsModal